import api from './api'

// 活跃圈子
export function getPlusGroup (params) {
    return api.get('/plus-group/groups', { params, validateStatus: s => s === 200 })
  }

//   回答
  
export function getQuestions (params) {
    return api.get('/questions', { params, validateStatus: s => s === 200 })
}

//   最新回答
  
export function getQuestionsAnswer (params) {
  return api.get('/question-answers', { params, validateStatus: s => s === 200 })
}

//   分享

export function getFeeds (params) {
    return api.get('/feeds', { params, validateStatus: s => s === 200 })
  }